import { useTranslation } from 'react-i18next'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { IMAGE_SIZES, URL_CATEGORY_POPULAR_PRODUCTS } from '@shared/contants'
import { Product, usePopularProductsQuery } from '@shared/generated'

export default function PopularProductsCarousel () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  
  const { data, loading } = usePopularProductsQuery({
    variables: {
      shopId: shopId,
      pager: {
        limit: 20,
        page: 1,
      },
      style: IMAGE_SIZES.TABLET
    },
  })
  return (
    <>
      {data && (
        <ProductCarousel
          link={URL_CATEGORY_POPULAR_PRODUCTS}
          title={tp('popular')}
          products={data.popularProducts?.edges as Product[]}
          loading={loading}
          listName="Popular Products"
        />
      )}
    </>
  )
}
